import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableShippySierraChatIntegration = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableShippySierraChatIntegration);
};
